import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import { default as Old2005BlogPage, doNothingAnchor } from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—February 2006" />
	<Old2005BlogPage>
		<h2>February 2006</h2>






		<h3 className="blogdate">
		Friday, February 10, 2006
		</h3>






		<h4 className="blogitemtitle">
		Dear Canada
		</h4>





			<div className="blogitembody">
			You know the saying "the grass is always greener on the other side of the fence?"  Sure you do.  Well, when I was in Queensland, Australia the past months, as the tropical build-up began, I was surely heard to say <em>"krikey, this is hot, too hot to do anything, and too humid!"</em> and <em>"in Canada, we can moderate our temperature by adding or removing layers of clothing!"</em>  Well, now I am in Canada, where it is cold, and I am caught saying <em>"I can't stand all of these clothes, one minute you are warm, the next you are too hot and sweaty!"</em>  I can't realistically be adding and removing layers each time I enter and leave a shop, or turn a street corner into the wind!<br /><br />I find this silly - that I was so quick to think that there was something better than my current situation.  Whereas before I was in sandals, shorts, and a light shirt, and was near the refreshing ocean, often searching for shade, and finding air conditioned shops to be too cold, now I am in thick socks, warm shoes, pants, second pants, shirt, jacket, second jacket, scarf, and toque, and sweating while I walk, yet near-comfortable when I am still.  This little rant about striving for a comfortable body temperature leads me to my realization.<br /><br />Nothing is ever perfect and, if I think it is, it won't seem that way for long.  I should realize and focus on what is good about where I am, wherever I want to be.  <em>Utopia is not a place, it is a state of mind</em> - I'm sure that is a quote, I just don't know who I am quoting.<br /><br />I would now like to write a suggestive and hopefully convincing letter to Canada:<br /><br /><em>Dear Canada,</em><br /><em></em><br /><em>What's the deal with pennies?  Aren't they a bit old-school, a bit of a nuisance?  If I tried to pay a cashier with one-hundred pennies, he would likely not accept my payment!  And can we as a nation agree that GST is to be included in all listed prices?  Let's have all taxes in each province included in all listed prices!</em><br /><em></em><br /><em>I was just in Australia, where the grass is greener, and where pennies are no longer circulated.  A cashier will round to the nearest five cents.  And all taxes are included in the listed prices.  It's so wonderful in Australia!</em><br /><em></em><br /><em>Sincerely,</em><br /><em></em><br /><em>Jesse Rivest</em><br /><br />Here is the reply from Canada:<br /><br /><em>Dear Jesse Rivest,</em><br /><em></em><br /><em>If you think the grass is more green on the other side of the fence, then why don't you cross the fence instead of whining to us?</em><br /><em></em><br /><em>Sincerely,</em><br /><em></em><br /><em>Canada</em>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 12:04 PM &nbsp;
			</div>






		<h3 className="blogdate">
		Wednesday, February 08, 2006
		</h3>






		<h4 className="blogitemtitle">
		Michael Franti is coming to Calgary!
		</h4>





			<div className="blogitembody">
			How cool is this? Michael Franti is coming to Calgary, to the Uptown Theatre, March 30, to screen his movie "I Know I'm Not Alone"!! After the screening, he is holding a Question &amp; Answer session, and then doing an unplugged performance of some of his songs! I do hope to be in attendance that evening.<br /><br />Yesterday I met with Josh to discuss recording my songs, all went well - we both want the same things for this recording - and we booked the studio for February 17. I am excited! It's 10 days away, so I will be taking 'er easy, drinking hot water, reading "Life of Pi" and feeling out my songs so that the day goes well. I drink a lot of hot water these days, in fact I haven't had a glass of cold water since returning to Canada. In my later months in Queensland, Australia, there was no cold water faucet on a sink, just scalding HOT or sun-baked WARM. So I am quite accustomed to warm water. Now I take the water from the COLD faucet and boil it just to keep myself warm!<br /><br />Also exciting is my first gig in Calgary - February 24 - check out the Performances section of my site for the details! I must thank Dave Simpson for this gig, as it is his gig, and he has invited me to share the evening with him! Thanks Dave! Dave figures we'll each do 1.5 hours to keep everyone entertained for the evening.<br /><br />Links:<br /><br /><Link to="/events/">Performances </Link><br /><a href="/" onClick={doNothingAnchor}>http://www.davesimpsonmusic.com/</a><br /><a href="http://www.spearheadvibrations.com/">http://www.spearheadvibrations.com/</a><br /><a href="http://www.iknowimnotalone.com/">http://www.iknowimnotalone.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:31 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Thursday, February 02, 2006
		</h3>






		<h4 className="blogitemtitle">
		A Few Changes
		</h4>





			<div className="blogitembody">
			Well, I guess the biggest change is that I am no longer in Asia, instead I am in Canada! It's cold. To save myself from being shunned as a wussy, I should say that it is currently quite warm here, not nearly as cold as a Canadian Winter should be. I am quite happy about that, because... it's cold! I have been reacquainted with my friend Molson Canadian, I forgot all about him while I was away (I made other friends), but he is forgiving and is going to take me out soon and show me a good ol' Canadian time. He'll probably want to watch the hockey game, too, because he's always in the commercials. What a show-off!<br /><br />The next biggest change is: my website is under renovation. Yes that's right, time to renovate. How long will this take? I dunno, but I've seen some people live in homes while renovating for months and months. So maybe it will take months and months! I doubt it, though. I just need the site to be easier to maintain, and I want to make the front page more... full. If you look at the navigation links on the left, you will see there are new ones already appearing.<br /><br />Here's a change: my live interview with Craig Zonca, at ABC Radio Capricornia, is now available for download! Follow the "In the Media" link to find it. It's a biggy, so it might take you a bit to download it and listen to it. I want to publicly express my gratitude to Craig - he is a really cool dude - if you are in the Capricornia region (of Queensland, Australia), look for the band "November" and go meet him (and Pricey, too). I hope I have embarrassed him a bit. But not too much.<br /><br />Today I finished a song that I started writing in Rocky (Rockhampton, QLD, Australia). I went to the public library and stared, without focus, out a window and transported myself to Broome, WA, Australia. It was there (in Broome, spiritually) that I was finally able to finish this song. I shall call it "A Travelling Song."<br /><br />I am going to take this new song, along with a backpack full of others that I have written, and record a CD! I'll be residing in Calgary, commencing this weekend - Calgary is where my little CD project is going to happen. If you wish to help me in any way, send me an email and let me know the way (that you would like to help). E.g. I accept meals, preferably warm! Otherwise, sit back, relax, and check here again soon for a CD release!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:01 PM &nbsp;
			</div>








		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
